import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27b7a900"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cardHomePageFeature" }
const _hoisted_2 = {
  id: "testimonialCarousel",
  class: "carousel slide",
  "data-bs-ride": "carousel"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "carousel-indicators" }, [
  /*#__PURE__*/_createElementVNode("button", {
    "data-bs-target": "#testimonialCarousel",
    "data-bs-slide-to": "0",
    class: "active",
    "aria-current": "true",
    type: "button"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    "data-bs-target": "#testimonialCarousel",
    "data-bs-slide-to": "1",
    type: "button"
  })
], -1))
const _hoisted_4 = { class: "carousel-inner pb-5" }
const _hoisted_5 = { class: "carousel-item active" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-lg-4 d-flex justify-content-center mb-4" }
const _hoisted_8 = { class: "col-12 col-lg-4 d-flex justify-content-center mb-4" }
const _hoisted_9 = { class: "col-12 col-lg-4 d-flex justify-content-center mb-4" }
const _hoisted_10 = { class: "carousel-item" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 col-lg-6 d-flex justify-content-center mb-4" }
const _hoisted_13 = { class: "col-12 col-lg-6 d-flex justify-content-center mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTestimonial = _resolveComponent("CardTestimonial")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_CardTestimonial, {
                testimonial: _ctx.testimonialList[0]
              }, null, 8, ["testimonial"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_CardTestimonial, {
                testimonial: _ctx.testimonialList[1]
              }, null, 8, ["testimonial"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_CardTestimonial, {
                testimonial: _ctx.testimonialList[2]
              }, null, 8, ["testimonial"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_CardTestimonial, {
                testimonial: _ctx.testimonialList[3]
              }, null, 8, ["testimonial"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_CardTestimonial, {
                testimonial: _ctx.testimonialList[4]
              }, null, 8, ["testimonial"])
            ])
          ])
        ])
      ])
    ])
  ]))
}